export interface LeaveType {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  status: number;
  createdBy?: string;
  updatedBy?: string;
  ownerList?: string;
  deletedBy?: string;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  unpaidLeave: boolean;
  orgId?: number;
}

export interface LeaveTypeShort {
  id: string;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  unpaidLeave: boolean;
}

export interface LeaveTypeListRequest {
  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
  statusIn?: number[] | null;
}

export interface LeaveTypeCreateRequest {
  code: string;
  name: string;
  nativeName?: string;
  description: string;
  nativeDescription?: string;
  unpaidLeave: boolean;
  status: number;
}

export interface LeaveTypeUpdateRequest {
  id: string;
  code: string;
  name: string;
  nativeName?: string;
  description: string;
  nativeDescription?: string;
  unpaidLeave: boolean;
  status: number;
}

export interface LeaveTypeListResponse extends RestAPIMetaResponse {
  items: Array<LeaveType>;
}

export interface LeaveTypeListShortResponse extends RestAPIMetaResponse {
  items: Array<LeaveTypeShort>;
}

export enum TypeLeaveType {
  UNPAID = "unpaid",
  PAID = "paid",
}
